import React from 'react'
import { useTranslation } from 'react-i18next'
import { NumberInput } from '../../../../../../common/inputs/numberInput/NumberInput'
import { useFormState } from '../../../../wizard/useFormState'
import { ContentStateProperty } from '../../../../../../../@types/types'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'

export interface HeatingCostsProps {
  screenId: string
  heatingCosts?: string
  heatingCostsValidation: string[]
  onChange: (property: ContentStateProperty, value: string | undefined) => void
  onFocusEnter?: () => void
  onFocusLeave?: () => void
  useSimpleLayout?: boolean
  showLabel?: boolean
}

const HeatingCosts: React.FC<HeatingCostsProps> = ({
  heatingCosts,
  heatingCostsValidation,
  onChange,
  onFocusEnter,
  onFocusLeave,
  useSimpleLayout = false,
  showLabel = false,
}) => {
  const { formState } = useFormState()
  const { t } = useTranslation()

  const showErrors = () =>
    heatingCostsValidation.length > 0 && (formState.submitCount > 0 || formState.touched.heatingCosts)
  const getLabel = () => (showLabel ? <span>{t('wizard.screen.costs.heatingCosts')}</span> : undefined)
  const getPlaceholder = () => (!showLabel ? t('wizard.screen.costs.heatingCosts') : '')

  const numberInput = (
    <NumberInput
      id='heating-costs'
      propertyName='heatingCosts'
      placeholder={getPlaceholder()}
      label={getLabel()}
      value={heatingCosts ? parseNumber(heatingCosts) : undefined}
      minPrecision={0}
      maxPrecision={2}
      affixRight='unit'
      unitRight='eur'
      errors={[]}
      showRedBoarder={heatingCostsValidation.length > 0}
      doOnFieldChange={(property, value) => onChange(property, formatNumber(value))}
      onFocus={onFocusEnter}
      onBlur={onFocusLeave}
    />
  )

  if (useSimpleLayout) {
    return <div>{numberInput}</div>
  }

  return (
    //The chosen intervals have been adjusted to the AGENT apartment rent flow
    <div className='inline-block margin-top-m one-whole'>
      <div className='inline-block vertical-center-container two-twelfth'>
        <span className='vertical-center lap-margin-left-m desk-margin-left-m margin-left-xxl path-symbol-before' />
      </div>
      <div className='inline-block ten-twelfth'>{numberInput}</div>
      {showErrors() && (
        <span
          role='alert'
          className='inline-block input-label-helper-text font-error'
          aria-label={t('wizard.screen.costs.heatingCosts', 'Heating Costs')}
        >
          {t(`validation.${heatingCostsValidation[0]}`)}
        </span>
      )}
    </div>
  )
}

export default HeatingCosts
